import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import {
  getTeamGuid,
  getCurrencyCode,
  getTeamFundraisingTarget,
} from '../../selectors/apiSelectors';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';

const updateFundraisingData = (fundraisingTarget?: number | string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UPDATE_FUNDRAISING_DATA;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state);
    const currencyCode = getCurrencyCode(state);
    const targetAmount = !fundraisingTarget
      ? getTeamFundraisingTarget(state)
      : fundraisingTarget;
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/fundraising`,
      {
        method: 'PUT',
        body: JSON.stringify({
          currencyCode,
          targetAmount: targetAmount === '' ? null : targetAmount,
        }),
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_FUNDRAISING_DATA);
    }

    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    redirectByResponseStatus(error.status);
    throw error;
  }
};

export default updateFundraisingData;
